import React from 'react';
import './NotFound.css';

export default () => (
  <div className="NotFound">
    <h1>404</h1>
    <h3>Page not found!</h3>
  </div>
);


// WEBPACK FOOTER //
// ./src/containers/NotFound.js